export const educationData = [
    {
        id: 1,
        institution: 'IHT COMPUTER COLLEGE',
        course: 'DIPLOMA COURSE IN WEB DESIGNING',
        startYear: '2021',
        endYear: '2022'
    },
    {
        id: 2,
        institution: 'MIC HIGHER SECONDARY',
        course: 'Higher Secondary',
        startYear: '2019',
        endYear: '2021'
    },
    {
        id: 3,
        institution: "MA'DIN PUBLIC SCHOOL [CBSE]",
        course: 'Secondary School',
        startYear: '2007',
        endYear: '2019'
    },
]